/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-resource-sidebar-actions',
  template: `
    <a *ngIf="!readOnly"
       class="btn btn-xs btn-default"
       [class.disabled]="isEditActive"
       [attr.aria-disabled]="isEditActive"
       [attr.href]="editHref"
       (click)="goToEdit($event)">
      <span class="fa fa-fw fa-edit"></span>
      <span>{{ 'button.edit' | ogTranslate }}</span>
    </a>
  `
})
export class ResourceSidebarActionsComponent {
  @Input() readOnly: boolean;
  /** Optional override when item state is not the current state. */
  @Input() editStateName: string;

  constructor(private readonly $state: StateService) {
  }

  get editHref(): string {
    return this.$state.href(
      this.resolveEditStateName(),
      this.$state.params,
      {inherit: false}
    ) || '';
  }

  get isEditActive(): boolean {
    return this.$state.is(this.resolveEditStateName());
  }

  goToEdit(event: Event): void {
    if (this.isEditActive) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    this.$state.go(this.resolveEditStateName());
  }

  private resolveEditStateName(): string {
    if (this.editStateName) {
      return this.editStateName;
    }
    // Hard-code from current item state because context components do not have
    // a reference point for a relative uiSref such as ".edit".
    return this.$state.current.name + '.edit';
  }

}
